"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (auth) => new Promise((resolve, reject) => {
    auth.request((err, token) => {
        if (err != null || token == null) {
            reject(err);
            return;
        }
        resolve(token);
    });
});
//# sourceMappingURL=auth.js.map